import api from '@axios'

export default {
  namespaced: true,
  state: {
    confirmed_payment: {
      amount: 0,
    },
    data_payment: null,
    id_pedido_pagarme: null,
  },
  getters: {
    confirmed_payment: state => state.confirmed_payment,
    data_payment: state => state.data_payment,
    id_pedido_pagarme: state => state.id_pedido_pagarme,
  },
  mutations: {
    SET_CONFIRMED_PAYMENT(state, payload) {
      state.confirmed_payment = payload
    },
    SET_DATA_PAYMENT(state, payload) {
      state.data_payment = payload
    },
    SET_ID_PEDIDO_PAGARME(state, payload) {
      state.id_pedido_pagarme = payload
    },
  },
  actions: {
    submitForm({ commit }, { data, patchApi, methodPayment }) {
      return new Promise((resolve, reject) => {
        api.post(`/efetuarPagamento?method_payment=${methodPayment}`, data).then(res => {
          commit('SET_CONFIRMED_PAYMENT', res.data.status === 'paid')
          if (patchApi === 'assinaturas') {
            commit('SET_DATA_PAYMENT', res.data.data.charge.last_transaction)
          } else {
            commit('SET_DATA_PAYMENT', res.data.data.charges[0].last_transaction)
          }

          commit('SET_ID_PEDIDO_PAGARME', res.data.data.id)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    findByIdOrder({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        api.get(`/pageme/pedidos/${id}`).then(res => {
          console.log(res.data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
}
